import React, { Component } from 'react';
import { connect } from 'react-redux';
import classes from './SeatsMapListItem.scss';

import SeatsSelectPax from '../SeatsSelectPax/SeatsSelectPax';

import seatActive from '../../../../../assets/images/addons/seat-active.png';
import seatUnavailable from '../../../../../assets/images/addons/seat-unavailable.png';
import seatAvailable from '../../../../../assets/images/addons/seat-available.png';
import seatPaid from '../../../../../assets/images/addons/seat-paid.png';

import { hoverSeat, leaveSeat, saveSeat, selectSeat, deselectSeat, addAddon, removeAddon } from '../../../../../store/actions/index';

class SeatsMapListItem extends Component {
    render() {
        let seatValue = this.props.passengers.map(pax => {
            return pax.ssrDetails.ssrSeatDetails[this.props.seatsFlow === 'O' ? 0 : 1][this.props.seatsFlow === 'O' ? this.props.seatsOneWayIndex : this.props.seatsReturnIndex].seatValue;
        });
        return (
            <React.Fragment>
                {this.props.columnsAfterIndex.includes(this.props.itemIndex) ?
                    (
                    <React.Fragment>
                        {this.props.rseats.sc === "8" ? (
                            <li className={classes.Empty}></li>
                        ) : (
                            this.props.passengers.length === 1 ? (
                                <li onMouseLeave={this.props.rseats.avl ? this.props.onLeaveSeat : null} onClick={this.props.rseats.avl ? this.props.passengers[0].ssrDetails.ssrSeatDetails[this.props.seatsFlow === 'O' ? 0 : 1][this.props.seatsFlow === 'O' ? this.props.seatsOneWayIndex : this.props.seatsReturnIndex].seatValue === this.props.savedSeat.seatValue ? (e) => {
                                    console.log("Reacheddd innnnnn");
                                    e.stopPropagation();
                                    e.preventDefault();
                                    this.props.onRemoveAddon("Seats", parseInt(this.props.rseats.price, 10));
                                    this.props.onDeselectSeat(this.props.passengers[0].paxID, this.props.seatsFlow)
                                } : (e) => {
                                    console.log("Reacheddd");
                                    e.stopPropagation();
                                    e.preventDefault();
                                    this.props.onRemoveAddon("Seats", parseInt(this.props.passengers[0].ssrDetails.ssrSeatDetails[this.props.seatsFlow === 'O' ? 0 : 1][this.props.seatsFlow === 'O' ? this.props.seatsOneWayIndex : this.props.seatsReturnIndex].price, 10));
                                    this.props.onDeselectSeat(this.props.passengers[0].paxID, this.props.seatsFlow);
                                    this.props.onSelectSeat(this.props.passengers[0].paxID, this.props.seatsFlow)
                                    this.props.onAddAddon({addonLabel: "Seats", amount: parseInt(this.props.rseats.price, 10), legIndex: this.props.seatsFlow === 'O' ? this.props.seatsOneWayIndex : this.props.seatsReturnIndex, leg: this.props.seatsFlow === 'O' ? 'O' : 'R'})} : null
                                 } className={`u-relative u-cursorPointer`}>
                                    { this.props.rseats.avl ? seatValue.includes(this.props.rseats.sn) ? <img onMouseOver={() => saveSeatHandler(this.props)} src={seatActive} alt='Active'/> :  <img onMouseOver={() => saveSeatHandler(this.props)} src={this.props.rseats.price === 0 ? seatAvailable : seatPaid} alt='Seat Available'/> : <img src={seatUnavailable} alt='Seat Unavailable'/> }
                                    { this.props.rseats.avl && this.props.seatNo === this.props.rseats.sn && this.props.seatHovered ? <SeatsSelectPax seatNo={this.props.seatNo} price={this.props.rseats.price} /> : null }
                                </li>
                            ) : (
                                <li onMouseLeave={this.props.rseats.avl ? this.props.onLeaveSeat : null} className={`u-relative u-cursorPointer`}>
                                    { this.props.rseats.avl ? seatValue.includes(this.props.rseats.sn) ? <img src={seatActive} onMouseOver={() => saveSeatHandler(this.props)} alt='Active'/> : <img onMouseOver={() => saveSeatHandler(this.props)} src={this.props.rseats.price === 0 ? seatAvailable : seatPaid} alt='Seat Available'/> : <img src={seatUnavailable} alt='Seat Unavailable'/> }
                                    { this.props.rseats.avl && this.props.seatNo === this.props.rseats.sn && this.props.seatHovered ? <SeatsSelectPax seatNo={this.props.seatNo} price={this.props.rseats.price} /> : null }
                                </li>
                            )
                        )
                        }
                        <li className={classes.Empty}>{this.props.cabinNumber}</li>
                    </React.Fragment>
                    ) : 
                    <React.Fragment>
                        {this.props.rseats.sc === "8" ? (
                        <li className={classes.Empty}></li>
                    ) : (
                        this.props.passengers.length === 1 ? (
                            <li onMouseLeave={this.props.rseats.avl ? this.props.onLeaveSeat : null} onClick={this.props.rseats.avl ? this.props.passengers[0].ssrDetails.ssrSeatDetails[this.props.seatsFlow === 'O' ? 0 : 1][this.props.seatsFlow === 'O' ? this.props.seatsOneWayIndex : this.props.seatsReturnIndex].seatValue === this.props.savedSeat.seatValue ? (e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                console.log("Reached 2");
                                this.props.onRemoveAddon("Seats", parseInt(this.props.rseats.price, 10), this.props.seatsFlow === 'O' ? this.props.seatsOneWayIndex : this.props.seatsReturnIndex, this.props.seatsFlow === 'O' ? 'O' : 'R');
                                this.props.onDeselectSeat(this.props.passengers[0].paxID, this.props.seatsFlow)
                            } : (e) => {
                                e.stopPropagation();
                                e.preventDefault();
                                console.log("Reached 3");
                                console.log(this.props.rseats);
                                this.props.onRemoveAddon("Seats", parseInt(this.props.passengers[0].ssrDetails.ssrSeatDetails[this.props.seatsFlow === 'O' ? 0 : 1][this.props.seatsFlow === 'O' ? this.props.seatsOneWayIndex : this.props.seatsReturnIndex].price, 10), this.props.seatsFlow === 'O' ? this.props.seatsOneWayIndex : this.props.seatsReturnIndex, this.props.seatsFlow === 'O' ? 'O' : 'R');
                                this.props.onDeselectSeat(this.props.passengers[0].paxID, this.props.seatsFlow);
                                this.props.onSelectSeat(this.props.passengers[0].paxID, this.props.seatsFlow);
                                this.props.onAddAddon({addonLabel: "Seats", amount: parseInt(this.props.rseats.price, 10), legIndex: this.props.seatsFlow === 'O' ? this.props.seatsOneWayIndex : this.props.seatsReturnIndex, leg: this.props.seatsFlow === 'O' ? 'O' : 'R'})} : null
                             } className={`u-relative ${classes.ListItem}`}>
                                { this.props.rseats.avl ? seatValue.includes(this.props.rseats.sn) ? <img src={seatActive} onMouseOver={() => saveSeatHandler(this.props)} alt='Active'/> : <img onMouseOver={() => saveSeatHandler(this.props)} src={this.props.rseats.price === 0 ? seatAvailable : seatPaid} alt='Seat Available'/> : <img src={seatUnavailable} alt='Seat Unavailable'/> }
                                { this.props.rseats.avl && this.props.seatNo === this.props.rseats.sn && this.props.seatHovered ? <SeatsSelectPax seatNo={this.props.seatNo} price={this.props.rseats.price} /> : null }
                            </li>
                        ) : (
                            <li onMouseLeave={this.props.onLeaveSeat} className={`u-relative ${classes.ListItem}`}>
                                { this.props.rseats.avl ? seatValue.includes(this.props.rseats.sn) ? <img src={seatActive} onMouseOver={() => saveSeatHandler(this.props)} alt='Active'/> : <img onMouseOver={() => saveSeatHandler(this.props)} src={this.props.rseats.price === 0 ? seatAvailable : seatPaid} alt='Seat Available'/> : <img src={seatUnavailable} alt='Seat Unavailable'/> }
                                { this.props.rseats.avl && this.props.seatNo === this.props.rseats.sn && this.props.seatHovered ? <SeatsSelectPax seatNo={this.props.seatNo} price={this.props.rseats.price} /> : null }
                            </li>
                        )
                    )
                    }
                    </React.Fragment>      
                }
            </React.Fragment>
        );
    }
}

const saveSeatHandler = (props) => {
    props.onHoverSeat(props.rseats.sn);
    props.onSaveSeat(props.rseats)
}

const mapStateToProps = state => {
    return {
        seatNo: state.seats.seatNo,
        seatHovered: state.seats.seatHovered,
        passengers: state.farePrice.passengers,
        seatsFlow: state.farePrice.seatsFlow,
        seatsOneWayIndex: state.farePrice.seatsViewOneWayVal,
        seatsReturnIndex: state.farePrice.seatsViewReturnVal,
        savedSeat: state.farePrice.savedSeat
    }
}

const mapDispatchToProps = dispatch => {
    return {
        onHoverSeat: (seatNo) => dispatch(hoverSeat(seatNo)),
        onLeaveSeat: () => dispatch(leaveSeat()),
        onSaveSeat: (seat) => dispatch(saveSeat(seat)),
        onSelectSeat: (id, flow) => dispatch(selectSeat(id, flow)),
        onDeselectSeat: (id, flow) => dispatch(deselectSeat(id, flow)),
        onAddAddon: (addon) => dispatch(addAddon(addon)),
        onRemoveAddon: (label, amount, legIndex, leg) => dispatch(removeAddon(label, amount, legIndex, leg))
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(SeatsMapListItem);


// WEBPACK FOOTER //
// ./src/components/Addons/Seats/SeatsMap/SeatsMapListItem/SeatsMapListItem.js